import { Box, Typography } from "@material-ui/core";
import { B2BSpinner } from "halifax";
import React from "react";

import "./styles.scss";

interface AppLoadingScreenProps {
  logoSrc: string;
  logoAlt: string;
}

const AppLoadingScreen = ({ logoSrc, logoAlt }: AppLoadingScreenProps) => (
  <Box className="app-loading-screen-root">
    <Box className="app-loading-screen-content">
      <img
        className="app-loading-screen-logo"
        src={logoSrc}
        alt={logoAlt}
        loading="eager"
        decoding="sync"
      />
      <B2BSpinner style={{ width: "50px", height: "50px" }} />
      <Typography className="app-loading-screen-text">
        Loading...
      </Typography>
    </Box>
  </Box>
);

export default AppLoadingScreen;
